import { useCallback, useState } from 'react';
import { usePostFavoriteMarket } from '../queries/usePostFavoriteMarket';
import { useDeleteFavoriteMarket } from '../queries/useDeleteFavoriteMarket';
import { useShowRecommendedMarketsBottomSheet } from './useShowRecommendedMarketsBottomSheet';
import type { RecommendedMarket } from 'shared/src/api/marketService/getMarketDetail/types';
import { useLogClickFavoriteMarket } from './useLogClickFavoriteMarket';

export const useOnPressFavoriteMarket = (params: {
  sno: number;
  marketName: string;
  listId: string;
  recommendedMarketList: RecommendedMarket[];
  favorite: { market_sno: number; created_at: string } | null;
}) => {
  const { show: showRecommendedMarketBottomSheet } =
    useShowRecommendedMarketsBottomSheet();
  const [loadingLogClickFavoriteMarket, setLoadingLogClickFavoriteMarket] =
    useState(false);

  const logClickFavoriteMarket = useLogClickFavoriteMarket(params.sno);

  const {
    mutateAsync: postFavoriteMarket,
    isPending: loadingPostFavoriteMarket,
  } = usePostFavoriteMarket(params.sno);

  const {
    mutateAsync: deleteFavoriteMarket,
    isPending: loadingDeleteFavoriteMarket,
  } = useDeleteFavoriteMarket(params.sno);

  return {
    action: useCallback(async () => {
      if (params.favorite) {
        setLoadingLogClickFavoriteMarket(true);
        await logClickFavoriteMarket(true);
        setLoadingLogClickFavoriteMarket(false);
        return deleteFavoriteMarket();
      } else {
        setLoadingLogClickFavoriteMarket(true);
        await logClickFavoriteMarket(false);
        setLoadingLogClickFavoriteMarket(false);
        return postFavoriteMarket().then(result => {
          if (params.recommendedMarketList.length === 0) return result;

          showRecommendedMarketBottomSheet({
            marketName: params.marketName,
            marketSno: params.sno,
            recommendedMarkets: params.recommendedMarketList,
            listId: params.listId,
          });
          return result;
        });
      }
    }, [
      params.favorite,
      params.recommendedMarketList,
      params.marketName,
      params.sno,
      params.listId,
      logClickFavoriteMarket,
      deleteFavoriteMarket,
      postFavoriteMarket,
      showRecommendedMarketBottomSheet,
    ]),
    loading:
      loadingPostFavoriteMarket ||
      loadingDeleteFavoriteMarket ||
      loadingLogClickFavoriteMarket,
  };
};
